/**
 * MultiBuy Builder - discount.js
 * Pure discount-tier calculation engine. No DOM access.
 * Rules come from the merchant's theme-editor "discount_rule" blocks:
 *   [{ products_required: 2, discount_percent: 10 }, ...]
 * Attaches to window.MB.discount
 */
(function (window) {
  'use strict';

  var MB = (window.MB = window.MB || {});

  function normalizeRules(rules) {
    return (rules || [])
      .map(function (r) {
        return {
          products_required: parseInt(r.products_required, 10) || 0,
          discount_percent: parseFloat(r.discount_percent) || 0
        };
      })
      .filter(function (r) {
        return r.products_required > 0;
      })
      .sort(function (a, b) {
        return a.products_required - b.products_required;
      });
  }

  /**
   * Returns the applicable tier for a given item count:
   * the highest rule whose products_required <= itemCount.
   */
  function getTier(rules, itemCount) {
    var sorted = normalizeRules(rules);
    var tier = null;
    for (var i = 0; i < sorted.length; i++) {
      if (itemCount >= sorted[i].products_required) {
        tier = sorted[i];
      }
    }
    return tier;
  }

  function getNextTier(rules, itemCount) {
    var sorted = normalizeRules(rules);
    for (var i = 0; i < sorted.length; i++) {
      if (sorted[i].products_required > itemCount) {
        return sorted[i];
      }
    }
    return null;
  }

  function countItems(items) {
    return items.reduce(function (sum, i) {
      return sum + (i.quantity || 1);
    }, 0);
  }

  /**
   * items: [{ variantId, quantity, price (cents), compareAtPrice (cents) }]
   * Returns totals in cents plus the active discount tier.
   */
  function computeTotals(items, rules) {
    var itemCount = countItems(items);

    var subtotal = items.reduce(function (sum, i) {
      return sum + i.price * (i.quantity || 1);
    }, 0);

    var compareSubtotal = items.reduce(function (sum, i) {
      var compare = i.compareAtPrice && i.compareAtPrice > i.price ? i.compareAtPrice : i.price;
      return sum + compare * (i.quantity || 1);
    }, 0);

    var tier = getTier(rules, itemCount);
    var discountPercent = tier ? tier.discount_percent : 0;
    var discountAmount = Math.round(subtotal * (discountPercent / 100));
    var total = subtotal - discountAmount;
    var savings = compareSubtotal - total;

    return {
      itemCount: itemCount,
      subtotal: subtotal,
      compareSubtotal: compareSubtotal,
      discountPercent: discountPercent,
      discountAmount: discountAmount,
      total: total,
      savings: Math.max(savings, 0),
      tier: tier,
      nextTier: getNextTier(rules, itemCount)
    };
  }

  MB.discount = {
    normalizeRules: normalizeRules,
    getTier: getTier,
    getNextTier: getNextTier,
    countItems: countItems,
    computeTotals: computeTotals
  };
})(window);
